<template lang="pug">
    v-dialog(v-model="dialog" width="700" persistent)
        template(v-slot:activator="{ on, attrs }")
            v-btn.ml-2(small :color="item === null ? 'green' : 'primary'" dark v-bind="attrs" v-on="on")
                v-icon(small left) mdi-pencil
                | Update Options
        v-card
            v-card-title Update Survey Options
            v-card-text

                v-form(
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    :disabled="loading"
                )
                    v-text-field(
                        v-model="form.key.title"
                        :rules="titleRules"
                        label="Title"
                        required
                        dense
                        outlined
                    )

                    v-expansion-panels(:key="item.key.id")
                        v-expansion-panel
                            v-expansion-panel-header
                                b YES
                            v-expansion-panel-content
                                template(v-for="(item, index) in form.yes")
                                    v-text-field(
                                        v-model="form.lists[item.id].title"
                                        :rules="titleRules"
                                        :label="`${index + 1}`"
                                        required
                                        dense
                                        outlined
                                        :key="`yes-${item.id}`"
                                    )
                        v-expansion-panel
                            v-expansion-panel-header
                                b NO
                            v-expansion-panel-content
                                template(v-for="(item, index) in form.no")
                                    v-text-field(
                                        v-model="form.lists[item.id].title"
                                        :rules="titleRules"
                                        :label="`${index + 1}`"
                                        required
                                        dense
                                        outlined
                                        :key="`no-${item.id}`"
                                    )

            v-divider
            v-card-actions
                v-spacer
                v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
                v-btn(small color="primary" text @click="update" :loading="loading") Submit
</template>


<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        id: Number,
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            valid: false,
            form: {
                key: this.item.key,
                yes: [...this.item.yes],
                no: [...this.item.no],
                lists: {
                    ...[...this.item.yes, ...this.item.no].reduce((ret, item) => {
                        if(!ret[item.id]) ret[item.id] = item;
                        return ret;
                    }, {})
                }
            },
            titleRules: [
                v => !!v || 'Title is required'
            ],
        };
    },
    computed: {
        ...mapGetters('bh-survey-options', { getOption: 'get' })
    },
    created() {
        this.getServerOption(this.form.key.id)
        Object.keys(this.form.lists).map(async id => {
            await this.getServerOption(Number(id));
        });
    },
    methods: {
        async update() {
            if(this.valid) {
                try {
                    this.loading = true;
                    const updatedIdLists = [];
                    await this.updateData(this.form.key, updatedIdLists);
                    for(let id in this.form.lists) {
                        await this.updateData(this.form.lists[id], updatedIdLists);
                    }
                    if(updatedIdLists.length !== 0) 
                        await this.getSuveyData({ query: {} });
                    this.$emit('success');
                    this.dialog = false;
                } catch(err) {
                    this.$emit('error', err.message);
                } finally {
                    this.loading = false;
                }
            }
        },
        async updateData(item, arr) {
            const current = this.getOption(item.id);
            if(current.title !== item.title && arr.indexOf(item.id) === -1) {
                await this.updateItem([item.id, {
                    title: item.title
                }]);
                arr.push(item.id);
            }
        },
        ...mapActions('bh-survey-options', { updateItem: 'patch', getServerOption: 'get' }),
        ...mapActions('bh-survey-option-tree', { getSuveyData: 'find' })
    }
}
</script>